const HAS_TIMEZONE_RE = /(?:Z|[+-]\d{2}:?\d{2})$/;

/** The backend serialises naive UTC datetimes (``"2026-10-05T09:00:00"``, no
 *  ``Z``). ``new Date()`` reads those as the viewer's local time, shifting every
 *  timestamp by the UTC offset; treat them as the UTC they are. */
export const parseServerDate = (value: string): Date =>
  new Date(
    value.includes("T") && !HAS_TIMEZONE_RE.test(value) ? `${value}Z` : value
  );
